import angular from 'angular'
import find from 'lodash/find'
import forEach from 'lodash/forEach'
import remove from 'lodash/remove'

/**
 * Controller MultiselectPopoverContentController
 *
 * @class MultiselectPopoverContentController
 */
export default class MultiselectPopoverContentController {
  constructor(options) {
    'ngInject'

    this.items = options.items || []
    this.key = options.key
    this.onSelect = options.onSelect
    this.selectedItems = options.selectedItems
    this.selectAllLabel = options.selectAllLabel
    this.selectAllState = this.selectedItems.length === this.items.length
  }

  /**
   * Determine if a given item is selected
   *
   * @method isSelected
   *
   * @param {Object} item
   *        The given item to check against the selected items
   *
   * @return {Boolean} True if the item is selected, false otherwise
   */
  isSelected(item) {
    let isSelected = false

    find(this.selectedItems, selectedItem => {
      if (item[this.key] === selectedItem[this.key]) {
        isSelected = true
      }
    })

    return isSelected
  }

  /**
   * Determine if the select all option is defined
   *
   * @method selectAllIsDefined
   *
   * @return {Boolean} True if the select all option is defined, false otherwise
   */
  selectAllIsDefined() {
    return angular.isDefined(this.selectAllLabel)
  }

  /**
   * Toggle the selected item
   * Will either add or remove the item from the selectedItems array based on the selected state
   *
   * @method toggleSelected
   *
   * @param {Object} item
   *        The given item to toggle selected / unselected
   */
  toggleSelected(item) {
    if (this.isSelected(item)) {
      remove(
        this.selectedItems,
        selectedItem => selectedItem[this.key] === item[this.key]
      )
    } else {
      this.selectedItems.push(item)
    }

    this.onSelect(this.selectedItems)

    this._evaluateSelectAll()
  }

  /**
   * Evaluate if we should apply the select all checkbox
   *
   * @private
   *
   * @method _evaluateSelectAll
   */
  _evaluateSelectAll() {
    if (this.items.length === this.selectedItems.length) {
      this.toggleSelectAll()
    } else {
      this.selectAllState = false
    }
  }

  /**
   * Toggle select all for the dropdown list
   *
   * @method toggleSelectAll
   */
  toggleSelectAll() {
    this.selectAllState = !this.selectAllState

    this.selectedItems.length = 0

    if (this.selectAllState) {
      forEach(this.items, item => this.selectedItems.push(item))
    }

    this.onSelect(this.selectedItems)
  }
}
